import { inject, Injectable } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";
import { PosthogService } from "@app/wapps/system/support/posthog.service";

@Injectable({
    providedIn: "root",
})
export class HtmlInjectorService {
    private _posthog = inject(PosthogService);

    public init() {
        if (AppConsts.PosthogEnabled) {
            this._posthog.init();
        }
    }
}
